import React from "react";
import Cards from "../components/Cards/Cards";
import Header from "../components/Header";

function Homepage({ increment }) {
  return (
    <>
      <Header />
      <Cards increment={increment} />
    </>
  );
}

export default Homepage;
